import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["icon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Cancel from '@mui/icons-material/Cancel';
import Check from '@mui/icons-material/CheckCircle';
import { alpha, FormControlLabel, formControlLabelClasses, Radio as DefaultRadio } from '@mui/material';
import { decodeHtmlEntities } from '../questions/utils/decode-html-entities';
import { RadioGroupFormBase } from '../radio-group-form-field';
import { jsx as _jsx } from "react/jsx-runtime";

var RadioBase = function RadioBase(_ref) {
  var icon = _ref.icon,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(DefaultRadio, _objectSpread(_objectSpread({
    disableRipple: true,
    disabled: true,
    color: "default",
    checkedIcon: icon,
    icon: icon
  }, props), {}, {
    "data-element": "DefaultRadio",
    "data-component": "RadioBase",
    "data-source-file": "quiz-input.tsx"
  }));
};

var SuccessRadio = function SuccessRadio(props) {
  return /*#__PURE__*/_jsx(RadioBase, _objectSpread(_objectSpread({
    icon: /*#__PURE__*/_jsx(Check, {
      sx: function sx(t) {
        return {
          fill: t.palette.success.main,
          width: 20,
          height: 20,
          ml: 0.25
        };
      }
    })
  }, props), {}, {
    "data-element": "RadioBase",
    "data-component": "SuccessRadio",
    "data-source-file": "quiz-input.tsx"
  }));
};

var FailRadio = function FailRadio(props) {
  return /*#__PURE__*/_jsx(RadioBase, _objectSpread(_objectSpread({
    icon: /*#__PURE__*/_jsx(Cancel, {
      sx: function sx(t) {
        return {
          fill: t.palette.error.main,
          width: 20,
          height: 20,
          ml: 0.25
        };
      }
    })
  }, props), {}, {
    "data-element": "RadioBase",
    "data-component": "FailRadio",
    "data-source-file": "quiz-input.tsx"
  }));
};

var customOptionStyles = function customOptionStyles(description, responseResult) {
  return _defineProperty({
    background: function background(t) {
      return alpha(description === (responseResult === null || responseResult === void 0 ? void 0 : responseResult.correctAnswer) ? t.palette.success.light : t.palette.error.light, 0.2);
    }
  }, "& .".concat(formControlLabelClasses.label, ".").concat(formControlLabelClasses.disabled), {
    color: function color(t) {
      return t.palette.text.primary;
    }
  });
};

var CustomRadio = function CustomRadio(_ref3) {
  var value = _ref3.value,
      responseResult = _ref3.responseResult;
  return value == (responseResult === null || responseResult === void 0 ? void 0 : responseResult.correctAnswer) ? /*#__PURE__*/_jsx(SuccessRadio, {}) : /*#__PURE__*/_jsx(FailRadio, {});
};

var QuizRadioButton = function QuizRadioButton(_ref4) {
  var value = _ref4.option.value,
      responseResult = _ref4.responseResult,
      selectedValue = _ref4.selectedValue;
  var isHighlighted = responseResult && selectedValue === value;
  return /*#__PURE__*/_jsx(FormControlLabel, {
    sx: [{
      m: 0
    }, !!isHighlighted && customOptionStyles(value, responseResult)],
    value: value,
    disabled: !!responseResult,
    control: isHighlighted || value === (responseResult === null || responseResult === void 0 ? void 0 : responseResult.correctAnswer) ? /*#__PURE__*/_jsx(CustomRadio, {
      value: value,
      responseResult: responseResult
    }) : /*#__PURE__*/_jsx(DefaultRadio, {}),
    label: decodeHtmlEntities(value),
    "data-element": "FormControlLabel",
    "data-component": "QuizRadioButton",
    "data-source-file": "quiz-input.tsx"
  });
};

var QuizInput = function QuizInput(_ref5) {
  var quiz = _ref5.quiz,
      _ref5$quizForm = _ref5.quizForm,
      control = _ref5$quizForm.control,
      errors = _ref5$quizForm.formState.errors,
      getValues = _ref5$quizForm.getValues,
      responseResults = _ref5.responseResults;
  var name = quiz.id;
  var error = errors[name];
  var responseResult = responseResults.find(function (_ref6) {
    var questionId = _ref6.questionId;
    return quiz.id === questionId;
  });
  return /*#__PURE__*/_jsx(RadioGroupFormBase, {
    control: control,
    name: name,
    options: quiz.options.map(function (_ref7) {
      var description = _ref7.description;
      return {
        value: description
      };
    }),
    required: true,
    error: error,
    formControlLabel: function formControlLabel(option, index) {
      return /*#__PURE__*/_jsx(QuizRadioButton, {
        option: option,
        selectedValue: getValues(quiz.id),
        responseResult: responseResult
      }, index);
    },
    "data-element": "RadioGroupFormBase",
    "data-component": "QuizInput",
    "data-source-file": "quiz-input.tsx"
  });
};

export default QuizInput;